import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

const neonBorder = keyframes`
  0% {
    box-shadow: 0 0 5px #6d5dfc, 0 0 10px #6d5dfc, 0 0 20px #c277f2, 0 0 40px #c277f2, 0 0 80px #c277f2, 0 0 160px #c277f2;
  }
  50% {
    box-shadow: 0 0 10px #c277f2, 0 0 20px #c277f2, 0 0 40px #6d5dfc, 0 0 80px #6d5dfc, 0 0 160px #6d5dfc, 0 0 320px #6d5dfc;
  }
  100% {
    box-shadow: 0 0 5px #6d5dfc, 0 0 10px #6d5dfc, 0 0 20px #c277f2, 0 0 40px #c277f2, 0 0 80px #c277f2, 0 0 160px #c277f2;
  }
`;


const HomeContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding-top: 80px;
  background-color: #111;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-around;
  }
`;


const TextContainer = styled.div`
  flex: 1;
  text-align: center;
  padding: 20px;

  @media (min-width: 768px) {
    text-align: left;
    padding: 0 40px;
  }
`;

const Title = styled.h1`
  font-size: 2.2rem;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    font-size: 2.8rem;
  }
`;

const Subtitle = styled.h2`
  font-size: 1.2rem;
  margin-bottom: 30px;
  position: relative;

  &::after {
    content: '|';
    position: absolute;
    right: -12px;
    animation: blink 1s infinite;
  }

  @keyframes blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0; }
  }

  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
`;

const Button = styled.button`
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: 500;
  margin: 0 10px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
  box-shadow: 0px 5px 15px rgba(0,0,0,0.2);

  &:hover {
    transform: translateY(-2px);
    opacity: 0.9;
  }
`;

const ResumeButton = styled(Button)`
  background-color: #007bff;
`;

const ContactButton = styled(Button)`
  background-color: #28a745;
`;

const ImageContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ProfileImage = styled.img`
  width: 220px;
  height: 220px;
  border-radius: 50%;
  animation: ${neonBorder} 5s infinite alternate;
  object-fit: cover;

  @media (min-width: 768px) {
    width: 300px;
    height: 300px;
  }
`;

const Home = () => {
  const roles = ['Frontend Developer', 'Backend Developer', 'Python Developer','Embedded Engineer'];
  const [displayedText, setDisplayedText] = useState(roles[0]);
  const [isRemoving, setIsRemoving] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (isRemoving) {
        if (displayedText.length > 0) {
          setDisplayedText(displayedText.slice(0, -1));
        } else {
          setIsRemoving(false);
          setCurrentIndex((prevIndex) => (prevIndex + 1) % roles.length);
        }
      } else {
        if (displayedText.length < roles[currentIndex].length) {
          setDisplayedText(roles[currentIndex].slice(0, displayedText.length + 1));
        } else {
          setIsRemoving(true);
        }
      }
    }, 100);

    return () => clearInterval(interval);
  }, [displayedText, isRemoving, currentIndex, roles]);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) section.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <HomeContainer>
      <ImageContainer>
        <ProfileImage
          src="https://lh3.googleusercontent.com/d/1D3G5IYDfzU60lX546XsdOYj3vDCTt1XD"
          alt="Abhishek Pratap Singh"
        />
      </ImageContainer>
      <TextContainer>
        <Title>Hello, I’m Abhishek Pratap Singh</Title>
        <Subtitle>I am {displayedText}</Subtitle>
        <div>
          <ResumeButton
            onClick={() =>
              window.open(
                'https://drive.google.com/file/d/18KIxDDLimbiIR3fEVPPxIOckoHM7K_TO/view?usp=sharing',
                '_blank'
              )
            }
          >
            Resume
          </ResumeButton>
          <ContactButton onClick={() => scrollToSection('contact')}>
            Contact Me
          </ContactButton>
        </div>
      </TextContainer>
    </HomeContainer>
  );
};

export default Home;
